module.exports = __webpack_public_path__ + "img/2.319f517d.jpg";